import { 
  Phone, 
  Envelope, 
  MapPin, 
  WhatsappLogo,
  LinkedinLogo,
  InstagramLogo
} from "@phosphor-icons/react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_recuperar-trabajo-1/artifacts/wdfmoy8t_LOGO%20CON%20NIT.jpeg";

const footerLinks = [
  {
    title: "Servicios",
    links: [
      { name: "Obra Civil", href: "#servicios" },
      { name: "Mantenimiento Locativo", href: "#servicios" },
      { name: "Pisos Industriales", href: "#servicios" },
      { name: "Apoyo Operativo", href: "#servicios" },
      { name: "Instalaciones Técnicas", href: "#servicios" }
    ]
  },
  {
    title: "Empresa",
    links: [
      { name: "Quiénes Somos", href: "#nosotros" },
      { name: "Experiencia", href: "#experiencia" },
      { name: "Valores", href: "#nosotros" },
      { name: "Contacto", href: "#contacto" }
    ]
  }
];

export function Footer() {
  const handleNavClick = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer
      data-testid="footer"
      className="bg-[#0F172A] text-white relative overflow-hidden"
    >
      {/* Main Footer */}
      <div className="container mx-auto px-6 py-16 lg:py-24">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {/* Brand */}
          <div className="lg:col-span-1">
            <img
              src={LOGO_URL}
              alt="SEINMAR S.A.S."
              className="h-16 w-auto object-contain mb-6 brightness-0 invert"
            />
            <p className="text-slate-400 leading-relaxed mb-6">
              Obra civil y mantenimiento industrial con enfoque en seguridad, 
              cumplimiento y continuidad operativa.
            </p>
            <div className="flex gap-4">
              <a
                href="https://wa.me/573233230210"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-lg bg-white/10 flex items-center justify-center hover:bg-[#25D366] transition-colors"
                data-testid="footer-whatsapp"
              >
                <WhatsappLogo size={20} weight="fill" />
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-lg bg-white/10 flex items-center justify-center hover:bg-[#0077B5] transition-colors"
                data-testid="footer-linkedin"
              >
                <LinkedinLogo size={20} weight="fill" />
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-lg bg-white/10 flex items-center justify-center hover:bg-gradient-to-br hover:from-[#833AB4] hover:via-[#FD1D1D] hover:to-[#F77737] transition-colors"
                data-testid="footer-instagram"
              >
                <InstagramLogo size={20} weight="fill" />
              </a>
            </div>
          </div>

          {/* Links */}
          {footerLinks.map((section) => (
            <div key={section.title}>
              <h4 className="text-lg font-bold mb-6">{section.title}</h4>
              <ul className="space-y-3">
                {section.links.map((link) => (
                  <li key={link.name}>
                    <a
                      href={link.href}
                      onClick={(e) => handleNavClick(e, link.href)}
                      className="text-slate-400 hover:text-white transition-colors"
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          {/* Contact */}
          <div>
            <h4 className="text-lg font-bold mb-6">Contacto</h4>
            <ul className="space-y-4">
              <li>
                <a
                  href="tel:+573233230210"
                  className="flex items-center gap-3 text-slate-400 hover:text-white transition-colors"
                >
                  <Phone size={18} weight="duotone" className="text-[#C92127]" />
                  323 323 0210
                </a>
              </li>
              <li>
                <a
                  href="tel:+573112515236"
                  className="flex items-center gap-3 text-slate-400 hover:text-white transition-colors"
                >
                  <Phone size={18} weight="duotone" className="text-[#C92127]" />
                  311 251 5236
                </a>
              </li>
              <li>
                <a
                  href="mailto:victor.pinto@seinmarc.com"
                  className="flex items-center gap-3 text-slate-400 hover:text-white transition-colors"
                >
                  <Envelope size={18} weight="duotone" className="text-[#C92127]" />
                  victor.pinto@seinmarc.com
                </a>
              </li>
              <li className="flex items-start gap-3 text-slate-400">
                <MapPin size={18} weight="duotone" className="text-[#C92127] mt-1" />
                <span>Cali, Valle del Cauca, Colombia</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="container mx-auto px-6 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-slate-500 text-sm">
              © {new Date().getFullYear()} SEINMAR S.A.S. - Servicios Integrales Marconi. 
              NIT 901844140-3. Todos los derechos reservados.
            </p>
            <p className="text-slate-500 text-sm">
              Cali, Valle del Cauca, Colombia
            </p>
          </div>
        </div>
      </div>

      {/* Large Background Text */}
      <div className="absolute bottom-0 left-0 right-0 overflow-hidden pointer-events-none">
        <p 
          className="text-[15vw] font-extrabold text-white/[0.02] whitespace-nowrap leading-none"
          style={{ fontFamily: 'Chivo, sans-serif' }}
        >
          SEINMAR
        </p>
      </div>
    </footer>
  );
}

export default Footer;
